<template>
  <div>
    <page-heading title="404"></page-heading>
    <el-card>
      <h2 align="center">{{ $t(`${translationPrefix}.messages.text`) }}</h2>
      <img src="@/assets/img/logos/logo-h.png" class="logo horizontal">
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'Error',
    data() {
      return {
        translationPrefix: 'pages.error',
      };
    },
  };
</script>
<style lang="scss" scoped>
  .el-card{
    min-height: 300px;
  }
  .logo{
    max-width: 200px;
    display: block;
    margin: auto;
    padding: 20px 0px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Error.vue